<template>
  <div>
    <template v-if="!isLoading && !emptyFeedback">
      <b-avatar
        size="35px"
        variant="primary"
        :badge="showBadge"
        :badge-left="showBadge"
        :badge-variant="badgeVariant"
        :text="userInfo.userInitials"
        :src="userInfo.avatar"
        :id="`datatable-avatar-${userInfo.id}-${_uid}`"
      >
        <template #badge v-if="showBadge"><b-icon :icon="badgeIcon"></b-icon></template>
      </b-avatar>
      <b-popover
        :target="`datatable-avatar-${userInfo.id}-${_uid}`"
        triggers="hover focus"
        boundary="viewport"
        placement="top"
      >
        <div class="text-center">
          <strong>{{ userInfo.name }}</strong> <br>
          {{ date }}
        </div>
      </b-popover>
    </template>
    <b-skeleton type="avatar" v-else-if="isLoading && !emptyFeedback"></b-skeleton>
    <template v-if="emptyFeedback">N/A</template>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      userInfo: null,
      emptyFeedback: false
    }
  },
  computed: {
    date () {
      if (this.value?.date) {
        return moment(this.value.date).format('DD-MM-YYYY HH:mm')
      }
      return null
    },
    userId () {
      return this.value?.user?.id || this.value.user || null
    },
    showBadge () {
      return typeof this.value.user === 'object' && 'done' in this.value.user
    },
    badgeVariant () {
      if (this.showBadge) {
        return this.value.user.done === false ? 'danger' : 'success'
      }
      return null
    },
    badgeIcon () {
      if (this.showBadge) {
        return this.value.user.done === false ? 'dash-circle' : 'check'
      }
      return null
    }
  },
  methods: {
    async loadUserInfo () {
      const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${this.userId}`)
      this.userInfo = {
        id: res.data.id,
        name: `${res.data.firstname} ${res.data.lastname}`,
        userInitials: res.data?.userInitials,
        avatar: res.data?.profilePicture || ''
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.userId) {
        await this.loadUserInfo()
      } else {
        this.emptyFeedback = true
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
